var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"param over-scroll"},_vm._l((_vm.curData),function(o,i){return _c('h3',{key:i},[_vm._v(_vm._s(i)+":"+_vm._s(o)+"\n  ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }